import React from 'react';

import { Button } from 'app/SharedComponents/Button/Button';

import { ModalBase, ModalBaseProps } from '.';

export interface ModalConfirmationProps extends ModalBaseProps {
  buttonAlignment?: 'column' | 'row';
  buttonCancelText?: string;
  buttonConfirmText?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
}

export const ModalConfirmation = React.memo(
  ({
    buttonAlignment = 'row',
    buttonCancelText,
    buttonConfirmText,
    children,
    onCancel,
    onConfirm,
    ...props
  }: ModalConfirmationProps) => (
    <ModalBase {...props}>
      {children}
      {(typeof onCancel === 'function' || typeof onConfirm === 'function') && (
        <div
          className={`w-100 flex justify-between gap-x-4 mt-4 ${
            buttonAlignment === 'column' && 'flex-col-reverse gap-4'
          }`}
        >
          {typeof onCancel === 'function' && (
            <Button
              fullWidth
              onClick={onCancel}
              variant="outlined"
              data-testid="button-cancel"
            >
              {buttonCancelText}
            </Button>
          )}
          {typeof onConfirm === 'function' && (
            <Button
              fullWidth
              onClick={onConfirm}
              variant="contained"
              data-testid="button-confirm"
            >
              {buttonConfirmText}
            </Button>
          )}
        </div>
      )}
    </ModalBase>
  ),
);
